import * as THREE from 'three'
import { MathUtils } from 'three'
import { useEffect, useRef, useState } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import * as Tone from 'tone'
import inst from "./inst"
import { Instances, Instance } from '@react-three/drei'
import anime from 'animejs/lib/anime.es.js';

let hit = 0;
let getInst = () => {
  hit++;
  return (hit % 2 === 0) ? inst.synthL : inst.synthR
}
let lerp = MathUtils.lerp


let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]
let notes = ["C", "D", "F", "G", "A"]
let octaves = [0, 1, 2, 3, 4, 5, 6, 7, 8]
let allNotes = new Array(notes.length * octaves.length).fill().fill().map((val, i) => {
  return notes[i % notes.length] + octaves[Math.floor(i / notes.length)]
})
let durs = [0.1]
let octaveOffset = 1;
let offsets = [1, 2, 3, 4,5]

function Sequence({ updated, length, ready, index, y = 4000, space = 1, width = 0.07, height = 0.05, pull, max, min, scale, ...props }) {
  const ref = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const ref4 = useRef()
  let time = 0;
  let dur = 0
  let durMult = getRand([0.8, 1.2])

  let data = Array.from({ length }, (v, i) => {
    let note = allNotes[i];
    let frac = 0.48 - (i / length)
    let size = 0.25
    let pos = {
      x: Math.cos(frac * Math.PI) * size,
      y: Math.sin(frac * Math.PI) * size * 1.5,
      z: 0
    }
    dur = getRand(durs) * durMult;
    time += dur
    let velocity = (Math.random() * dur * 2)
    let scale = 1
    return { time, note, i, pos, dur, currPos: { x: 0, y: 0, z: 0 }, velocity, scale, currScale: 1, durMult }
  });
  let currTime = 0;

  let loopEnd = time + dur
  const part = new Tone.Part(((time, val) => {
    if (!val.i) {
      mut.reverse = !mut.reverse
    }
    let s = getInst();
    let currI = !mut.reverse ? val.i : (length - 1) - val.i
    s.triggerAttackRelease(data[currI].note[0] + (parseInt(data[currI].note[1]) + octaveOffset), !currI ? val.dur*2 : val.dur*0.5, time, val.velocity);
    data[currI].scale = 6
    anime({
      targets: data[currI],
      scale: 1,
      duration: loopEnd * 4000
    })
    let chance = 1 - (length * 0.02)
    console.log(chance)
    if (!val.i && (Math.random() > chance)) {
      octaveOffset = getRand(offsets)
      console.log(octaveOffset)
    }

  }), data);

  useEffect(() => {
    if (ready) {
      part.start();
    }
    return () => part.stop()
  }, [ready, updated])
  part.loop = true;
  part.loopStart = 0;
  part.loopEnd = loopEnd;
  let spinSpeed = 0.0000001
  useFrame((state) => {
    //ref.current.rotation.set(0,ref.current.rotation.y + (rewind ? spinSpeed : -spinSpeed),0)
  })
  let sphere = new THREE.SphereBufferGeometry(width * 0.2, 16, 16)
  sphere.scale(3.5,1,1)
  let sphere2 = new THREE.SphereBufferGeometry(width * 0.4, 16, 16)
  sphere.scale(2,1,1)
  
  let octa = new THREE.OctahedronBufferGeometry(width * 0.3)
  octa.scale(4.5, 1, 1)

  let speed1 = 0.005 + Math.random() * 0.01
  let geo = getRand([octa, sphere])
  let len = 40
  let gapMax = 0.05
  let gapX = Math.random() * gapMax * 0.5
  let gapY = Math.random() * gapMax * 0.3
  let halfX = length * gapX
  let halfY = length * gapY*1.3
//  const matcap = useLoader(THREE.TextureLoader, './C7C7D7_4C4E5A_818393_6C6C74-512px.png')
  return (
    <>
      <Instances ref={ref} {...props} limit={2000} geometry={geo} position={[-halfX, -halfY, 0]}>
        <meshStandardMaterial roughness={0} color={getRand(['#FF7722','MediumSeaGreen','#21AAFF','#3EB489'])} />
        {new Array(len).fill().map((a, j) => (
          <group position={[(j * gapX), (j * gapY), 0]} rotation={[0, Math.PI * 3 * j / len, 0]}>
            {data.map((curr, i) => (
              <>
                <Note key={1} i={i} data={data} size={0.1} space={0} speed={0.003} pull={pull} min={min} scale={scale} />
              </>
            ))}
          </group>
        ))}
      </Instances>
    </>
  )
}


function Note({ i, size, data, pull, min, scale, speed }) {
  const ref = useRef()
  useFrame((state) => {
    let t = state.clock.getElapsedTime()
    let lerpScale = lerp(
      data[i].currScale,
      (data[i].scale) + ((5 - octaveOffset) * 0.3) * scale
      , speed * 3
    )
    data[i].currScale = lerpScale;

    ref.current.scale.setScalar(lerpScale * size * mut.zoom2)
    let p = pull * 0.02

    let x = data[i].currPos.x = lerp(
      data[i].currPos.x,
      -(octaveOffset* 0.03) + data[i].pos.x + (lerpScale - 0.8) * p,
      speed)

    let y = data[i].currPos.y = lerp(
      data[i].currPos.y,
      data[i].pos.y + (lerpScale - 1) * p,
      speed)

  ref.current.position.set(
    x * mut.zoom,
    y * mut.zoom,
    data[i].pos.z * mut.zoom
  )
})
return (
  <>
    <Instance ref={ref} />
  </>
)
}
let canSpawn = true;
let mut = { zoom: 1, zoom2: 1, rot: 0, rot2: 0, rot3: 0, reverse: false };
let easing = 'easeInQuart'
let easing2 = 'easeOutQuart'
let easing3 = 'easeInOutQuart'
let duration = 1000
let first = false
let rewind = false

export default function App() {
  const cam = useRef()
  
  const [ready, set] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [length, setLength] = useState(30)
  const click = () => {
    console.log(cam.current)
    cam.current.autoRotateSpeed = getRand([1,-1]) * 0.1
    Tone.Transport.start();
    Tone.context.resume();

    if (!first) {
      duration = 400
      first = true
    }
    if (canSpawn) {
      anime({
        targets: mut,
        zoom: 0,
        zoom2: 0,
        duration,
        easing,
      })
      setTimeout(() => {
        setLength(Math.floor(Math.random() * 20) + 10)
        setUpdated(!updated)
        set(true)
        canSpawn = false
        rewind = Math.random() > 0.5 ? true : false
        octaveOffset = getRand(offsets)
        setTimeout(() => {
          anime({
            targets: mut,
            zoom: 1,
            zoom2: 1,
            duration,
            easing: easing2,
          })
        }, 50)
        let dTime = 0.1 * Math.floor((Math.random() * 5))
        let dTime2 = 0.1 * Math.floor((Math.random() * 5))
        let rTime = 2 + Math.random() * 1
        inst.delayL.delayTime.linearRampToValueAtTime(dTime, rTime)
        inst.delayR.delayTime.linearRampToValueAtTime(dTime2, rTime)

      }, duration + 50)
      let val = 2000;
      let time = (duration * 2) / 1000;
      inst.filterL.frequency.rampTo(val, time * 0.5);
      inst.filterR.frequency.rampTo(val, time * 0.5)
      setTimeout(() => {
        inst.filterL.frequency.rampTo(inst.defaultFreq, time);
        inst.filterR.frequency.rampTo(inst.defaultFreq, time)

      }, time * 1000)
      anime({
        targets: mut,
        rot: mut.rot + getRand([1]) * getRand([1, -1]),
        duration: duration * 2,
        easing: easing3,
        complete: function (anim) {
          canSpawn = true
        }
      })

    }
  }
  let isMobile = window.innerWidth > 500
  return (
    <div className="fullscreen" onMouseDown={() => { click() }}>
      <Canvas dpr={[1, 2]} camera={{ position: [0, isMobile? 1.2 : 0.9, isMobile? 1.5 : 1], fov: 65 }}>
        <OrbitControls ref={cam} />
        <ambientLight intensity={0.75} />
        <color attach="background" args={['#000000']} />
        <pointLight position={[30, 10, -50]} intensity={20} color={"blue"} />
        <pointLight position={[-30, 10, 5]} intensity={60} color={"#E42217"} />
        <Sequence updated={updated} index={1} ready={ready} length={length} pull={(Math.random() * 1.5) - 0.75} min={(Math.random() * getRand([0.3, 0.5, 1.5])) + 0.02} scale={(Math.random() * 0.8) + 0.1} />
      </Canvas>
    </div>
  )
}

console.log('%c🌱🌱 @ramioso 2021-10-13 🌱🌱 ', 'color: orange');